export default __webpack_public_path__ + "static/media/uaeFlag.e92aca86.svg";